;(function(window) {
    console.log(window.pageContext);
    if (window.pageContext) {
        if (window.ns['app'])
            window.ns['app']['init']();
    }

    if (window.pageContext && window.pageContext['ns']) {
        window.ns[window.pageContext['ns']]['init']();
    }
})(window);